import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
const UserMinusIcon = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <g id="solid/user-minus"><g id="Icon"><path d="M13.2 6.00039C13.2 7.98862 11.5883 9.60039 9.60005 9.60039C7.61182 9.60039 6.00005 7.98862 6.00005 6.00039C6.00005 4.01217 7.61182 2.40039 9.60005 2.40039C11.5883 2.40039 13.2 4.01217 13.2 6.00039Z" fill="currentColor" /><path d="M2.45531 18.3039C2.38547 18.8656 2.66162 19.4087 3.13838 19.714C5.00356 20.9081 7.22089 21.6004 9.59993 21.6004C11.979 21.6004 14.1963 20.9074 16.0615 19.7131C16.5382 19.4078 16.8144 18.8648 16.7445 18.303C16.3028 14.7501 13.2725 12.0004 9.59993 12.0004C5.92737 12.0004 2.89704 14.7508 2.45531 18.3039Z" fill="currentColor" /><path d="M15.3 9.30039C14.803 9.30039 14.4 9.70334 14.4 10.2004C14.4 10.6974 14.803 11.1004 15.3 11.1004H21.9C22.3971 11.1004 22.8 10.6974 22.8 10.2004C22.8 9.70334 22.3971 9.30039 21.9 9.30039H15.3Z" fill="currentColor" /></g></g>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg width={24} height={24} viewBox="0 0 24 24" fill="none" aria-hidden="true" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default UserMinusIcon;